import { defineMessages } from 'react-intl';
export var messages = defineMessages({
  pageTitle: {
    id: 'Purchase.idealLanding.pageTitle',
    defaultMessage: 'ClassPass | Check email for subscription confirmation'
  },
  title: {
    id: 'Purchase.idealLanding.title',
    defaultMessage: 'All set - You will get an email any moment now confirming your subscription and then you’ll be ready to go!'
  },
  subtitle: {
    id: 'Purchase.idealLanding.checkEmail',
    defaultMessage: 'Please check your email for confirmation that your subscription has been activated.'
  },
  questions: {
    id: 'Purchase.idealLanding.questions',
    defaultMessage: 'Questions or need help?'
  },
  contactSupport: {
    id: 'Purchase.idealLanding.contactSupport',
    defaultMessage: 'Contact support'
  }
});